import { Spacer } from '@kizen/kds/Spacer';
import { Typography } from '@kizen/kds/Typography';
import BasicModal from '__components/Modals/presets/BasicModal';
import { MarketplacePlugin } from '__pages/Marketplace/types';
import { useTranslation } from 'react-i18next';

export const ConfirmationModal = ({
  confirmationModalProps,
  installedPlugin,
}: {
  confirmationModalProps: any;
  installedPlugin: MarketplacePlugin;
}) => {
  const { t } = useTranslation();

  return (
    <BasicModal
      {...confirmationModalProps}
      heading={t('Confirm Uninstall')}
      buttonText={t('Uninstall')}
    >
      <div>
        <Typography>
          {t(
            'Are you sure you want to uninstall {{name}}? This action will remove the app from all users of your business. If you change your mind, you can re-install it at any time.',
            {
              name: installedPlugin?.name,
            }
          )}
        </Typography>
        <Spacer size={5} />
      </div>
    </BasicModal>
  );
};
